export default {
  builtWithPioneers: 'Bygget sammen med vores kunder',
  introText1: 'Som en del af',
  introText2: 'Pioneers har udvalgte kunder gennem tiden været med til at teste, udfordre og forme vores løsninger.',
  introText3: 'Takket være Pioneers-programmet kan',
  introText3b: 'i dag levere mere stabile, gennemtestede og intelligente løsninger.',
  watchForInvites: 'Hold øje med invitationer til kommende tests',
  
  whatItWasTitle: 'Hvad Pioneers har været',
  whatItWasSubtitle: 'Et eksklusivt testprogram for udvalgte kunder',
  
  earlyAccessTitle: 'Tidlig adgang',
  earlyAccessText: 'Pioneers fik adgang til nye funktioner, før de blev lanceret til alle kunder.',
  
  directFeedbackTitle: 'Direkte feedback',
  directFeedbackText: 'Pioneers kunne give direkte input til udviklingsteamet og påvirke produktudviklingen.',
  
  realUsageTitle: 'Test i praksis',
  realUsageText: 'Pioneers testede funktioner i deres daglige brug og hjalp med at finde fejl og forbedringer.',
  
  whatItShapedTitle: 'Hvad det har formet – og hvad',
  whatItShapedTitle2: 'er i dag',
  shapedText1: 'Pioneers-programmet har givet os uvurderlig indsigt i, hvordan vores løsninger fungerer i praksis.',
  shapedText2: 'Mange af de funktioner og forbedringer, du ser i dag, er direkte resultat af feedback fra vores Pioneers.',
  shapedText3: 'Tak til alle der har bidraget!',
  
  closedTestsTitle: 'Lukkede tests i dag',
  closedTestsSubtitle: 'Beta-tests',
  closedTestsText1: 'Vi kører løbende lukkede tests af nye funktioner med udvalgte kunder.',
  closedTestsText2: 'Disse tests hjælper os med at sikre kvaliteten, før vi lancerer til alle.',
  closedTestsText3: 'Vil du være med? Hold øje med invitationer!',
  betaTests: 'Beta Tests',
  
  whatsComingTitle: 'Hvad kommer der?',
  whatsComingText1: 'Vi arbejder konstant på nye funktioner og forbedringer.',
  whatsComingText2: 'Som Pioneers-interesseret kan du få:',
  waitlistBenefit1: 'Tidlig adgang til nye funktioner',
  waitlistBenefit2: 'Mulighed for at påvirke produktudviklingen',
  waitlistBenefit3: 'Direkte kontakt til vores team',
  waitlistNote: 'Vi inviterer løbende nye testere baseret på behov.',
  waitlistComingSoon: 'Kommer snart',
  
  thankYouTitle: 'Tak til vores Pioneers',
  thankYouText1: 'Uden jer havde enkel energi ikke været, hvad det er i dag.',
  thankYouText2: 'Jeres feedback har gjort en reel forskel.',
  thankYouText3: 'Vi bygger videre på fundamentet fra',
  thankYouText3b: 'og den tilgang fortsætter.',
};